module.exports = __webpack_public_path__ + "img/zoom.6da0dbea.svg";